import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=f2c8c1ec&scoped=true&"
import script from "./AccordionSection.vue?vue&type=script&lang=ts&"
export * from "./AccordionSection.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=f2c8c1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c8c1ec",
  null
  
)

export default component.exports